import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Stack } from "@mui/material";
import { FaToolbox } from "react-icons/fa6";
import { FaPeopleGroup } from "react-icons/fa6";
import { MdGroupAdd } from "react-icons/md";
import { MdOutlineRateReview } from "react-icons/md";
import { GrDocumentUser } from "react-icons/gr";
import { MdReceiptLong } from "react-icons/md";
import { AddDealerTOJB360Tool } from "./AddDealerTOJB360Tool";
import { DealerAdminTool } from "./DealerAdminTool";
import { ClaimManagmentAdminTool } from "./ClaimManagmentAdminTool";
import DealerSummaryAdminTool from "./DealerSummaryAdminTool";
import InvoiceAdminTools from "./InvoiceAdminTools";
import InvoiceSummary from "./InvoiceSummary";
import { TbFileInvoice } from "react-icons/tb";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{ flexGrow: 1, overflow: "auto", minHeight: 0 }}
      {...other}
    >
      {value === index && <Box sx={{ pl: 2, pr: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export const JbwAdminTools = () => {
  const [value, setValue] = React.useState(0);
  const [tabView, setTabView] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        padding: 2,
        boxShadow: 4,
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        height: "calc(100vh - 80px)",
        overflow: "hidden",
      }}
    >
      {tabView === true ? (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              padding: 1,
              display: "flex",
              flexDirection: "row",
              flexShrink: 0,
            }}
          >
            <Typography variant="h6" component="h6">
              <FaToolbox />
              Admin Tools
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              bgcolor: "background.paper",
              display: "flex",
              overflow: "hidden",
            }}
          >
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: "divider" }}
            >
              <Tab
                icon={<FaPeopleGroup fontSize="30px" />}
                iconPosition="top"
                label="Dealer Lookup"
                {...a11yProps(0)}
              />
              <Tab
                icon={<MdGroupAdd fontSize="30px" />}
                iconPosition="top"
                label="Add Dealer"
                {...a11yProps(1)}
              />
              <Tab
                icon={<MdReceiptLong fontSize="30px" />}
                iconPosition="top"
                label="Invoice Lookup"
                {...a11yProps(2)}
              />
              <Tab
                icon={<MdOutlineRateReview fontSize="30px" />}
                iconPosition="top"
                label="Claim Management"
                {...a11yProps(3)}
              />

              <Tab
                icon={<GrDocumentUser fontSize="30px" />}
                iconPosition="top"
                label="Dealer Summary"
                {...a11yProps(4)}
              />
              <Tab
                icon={<TbFileInvoice fontSize="30px" />}
                iconPosition="top"
                label="Invoice Scanner"
                {...a11yProps(5)}
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              <DealerAdminTool />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <AddDealerTOJB360Tool />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <InvoiceAdminTools />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <ClaimManagmentAdminTool />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <DealerSummaryAdminTool />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <InvoiceSummary />
            </TabPanel>
          </Box>
        </Box>
      ) : (
        <>
          <Stack direction="row" spacing={2}>
            <Button
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                textTransform: "none",
                borderRadius: 2,
                height: 200,
                width: 200,
                m: 5,
              }}
              onClick={() => {
                setValue(0);
                setTabView(true);
              }}
              variant="contained"
              color="primary"
              size="large"
            >
              <FaPeopleGroup fontSize="100px" />
              Dealer Lookup
            </Button>
            <Button
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                textTransform: "none",
                borderRadius: 2,
                height: 200,
                width: 200,
                m: 5,
              }}
              onClick={() => {
                setValue(1);
                setTabView(true);
              }}
              variant="contained"
              color="secondary"
            >
              <MdGroupAdd fontSize="100px" />
              Add Dealer
            </Button>
            <Button
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                textTransform: "none",
                borderRadius: 2,
                height: 200,
                width: 200,
                m: 5,
              }}
              onClick={(e) => {
                setValue(2);
                setTabView(true);
              }}
              variant="contained"
              color="warning"
            >
              <MdReceiptLong fontSize="100px" />
              Invoice Lookup
            </Button>
            <Button
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                textTransform: "none",
                borderRadius: 2,
                height: 200,
                width: 200,
                m: 5,
              }}
              onClick={() => {
                setValue(3);
                setTabView(true);
              }}
              variant="contained"
              color="error"
            >
              <MdOutlineRateReview fontSize="100px" />
              Claim Management
            </Button>

            <Button
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                textTransform: "none",
                borderRadius: 2,
                height: 200,
                width: 200,
                m: 5,
              }}
              onClick={() => {
                setValue(4);
                setTabView(true);
              }}
              variant="contained"
              color="green"
            >
              <GrDocumentUser fontSize="100px" />
              Dealer Summary
            </Button>
            <Button
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                textTransform: "none",
                borderRadius: 2,
                height: 200,
                width: 200,
                m: 5,
              }}
              onClick={() => {
                setValue(5);
                setTabView(true);
              }}
              variant="contained"
              color="info"
            >
              <TbFileInvoice fontSize="100px" />
              Invoice Scanner
            </Button>
          </Stack>
        </>
      )}
    </Box>
  );
};
